import { CompetitionStaffFunction } from './competition-staff-function'
import { Injectable } from '@angular/core'

@Injectable()
export class CompetitionStaffFunctionSerializer {
  fromJson(json: any): CompetitionStaffFunction {
    const competitionStaffFunction = {
      ...json
    }

    return competitionStaffFunction
  }

  toJson(competitionStaffFunction: CompetitionStaffFunction): any {
    return {
      ...competitionStaffFunction
    }
  }
}
